function createProcessedComponentRegistry() {
  const processed = new WeakSet();

  return {
    shouldProcess(component) {
      if (!component || typeof component !== "object") {
        return true;
      }
      if (processed.has(component)) {
        return false;
      }
      processed.add(component);
      return true;
    },
  };
}

module.exports = { createProcessedComponentRegistry };
